<template>
  <b-sidebar id="add-new-subject-sidebar" :visible="isAddNewSubjectSidebarActive" bg-variant="white"
    sidebar-class="sidebar-lg" shadow backdrop no-header right @hidden="resetForm"
    @change="(val) => $emit('update:is-add-new-subject-sidebar-active', val)">
    <template #default="{ hide }">
      <div class="
          d-flex
          justify-content-between
          align-items-center
          content-sidebar-header
          px-2
          py-1
        ">
        <h5 class="mb-0">Add Subject</h5>
        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
      </div>
      <zape-gallery-model :props_hideShowModel="showImageModel" @modelClose="modelClose"
        @saveCategoryImage="saveImage" />
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <b-form class="p-2" @submit.prevent="handleSubmit(onSubmit)" @reset.prevent="resetForm">
          <validation-provider #default="validationContext" name="Subject Name" rules="required">
            <b-form-group label="Subject Name" label-for="Subject Name">
              <b-form-input id="Subject-Name" v-model="subject_data.subject_name" autofocus
                :state="getValidationState(validationContext)" trim />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider name="Type" v-slot="{ errors, valid, dirty }">
            <label>Select Type</label>
          <v-select
            class="w-100"
            v-model="subject_data.playtype"
            placeholder="Select Type"
            :clearable="false"
            :options="getModuleTypeOptions()"
            label="label"
            :reduce="option => option.value"
            >
            <template #option="{ label }">
              {{ label }}
            </template>
          </v-select>
        </validation-provider>
          <br />

          <template v-if="getFileExtensionFromUrl(subject_data.subject_img) == 'json'">
            <LottieView :url="subject_data.subject_img" :forEditTopics="true" :key="keyForLottie" />
          </template>
          <template v-else-if="getFileExtensionFromUrl(subject_data.subject_img) == 'lottie'">
            <DoLottieView :url="subject_data.subject_img" :forEditTopics="true" :id="`subject_img_${uuidv4()}`"
              :key="keyForLottie" />
          </template>
          <template v-else>
            <img style="width: 200px; height: 150px" :src="subject_data.subject_img" />
          </template>

          <!-- <img style="width: 200px; height: 150px" :src="subject_data.subject_img" alt="subject" /> -->
          <br />
          <br />
          <div class="d-flex gap-2">
            <b-button variant="primary" @click="showgalleryimage">
              <span class="d-none d-sm-inline">Image gallery</span>
            </b-button>
            <upload-image @saveUploadImage="saveUploadImage" />
          </div>
          <div class="d-flex bg-light text-light align-items px-3 py-2"
            style="position: absolute; bottom: 0%; left: 0%; width: 100%">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" type="submit" @click="hide"
              :disabled="submitbutton">
              Add
            </b-button>
            <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="button" style="margin-left: 10px"
              variant="outline-secondary" @click="hide">
              Cancel
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BCol,
  BFormFile,
  BFormSelect,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Ripple from "vue-ripple-directive";
import LottieView from "../../../components/question/LottieView.vue";
import DoLottieView from "../../../components/question/DoLottieView.vue";
import { v4 as uuidv4 } from 'uuid';
export default {
  components: {
    ZapeGalleryModel: () => import("../../../components/Model/ZapeGalleryModel.vue"),
    UploadImage: () => import("../../../components/Model/UploadImage.vue"),
    BSidebar,
    DoLottieView,
    LottieView,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BFormFile,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    uuidv4
  },
  directives: {
    Ripple,
  },
  model: {
    prop: "isAddNewSubjectSidebarActive",
    event: "update:is-add-new-subject-sidebar-active",
  },
  props: {
    isAddNewSubjectSidebarActive: {
      type: Boolean,
      required: true,
    },
    classId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      subject_data: {
        playtype:"",
        subject_name: "",
        subject_img:
          "https://t4.ftcdn.net/jpg/02/07/87/79/360_F_207877921_BtG6ZKAVvtLyc5GWpBNEIlIxsffTtWkv.jpg",
      },
      post_subject_data: "",
      showImageModel: false,
      keyForLottie: 0,
    };
  },
  computed: {
    submitbutton() {
      return !(
        this.subject_data.subject_name.length > 0 &&
        this.subject_data.subject_img.length > 0 &&
        this.subject_data.subject_img !== "https://t4.ftcdn.net/jpg/02/07/87/79/360_F_207877921_BtG6ZKAVvtLyc5GWpBNEIlIxsffTtWkv.jpg"
      );
    },
  },
  methods: {
    getModuleTypeOptions() {
      return [
        { label: 'TopicPlay', value: 'Topic Play' },
        { label: 'ModulePlay', value: 'Module Play' }
      ];
    },
    uuidv4,
    getFileExtensionFromUrl(url) {
      if (!url) return '';
      const path = url.split('?')[0].split('#')[0];
      const extension = path.split('.').pop();

      if (extension === path) return '';

      return extension;
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    resetForm() {
      this.subject_data = {
        subject_name: "",
        subject_img:
          "https://t4.ftcdn.net/jpg/02/07/87/79/360_F_207877921_BtG6ZKAVvtLyc5GWpBNEIlIxsffTtWkv.jpg",
      };
      this.validated = false;
    },
    onSubmit() {
      this.subject_data.class_id = this.classId;
      this.post_subject_data = this.subject_data;
      this.$emit("sendsubjectdata", this.post_subject_data);
    },
    saveUploadImage(url) {
      this.subject_data.subject_img = url;
    },
    modelClose(modelState) {
      this.showImageModel = modelState;
    },
    saveImage(url) {
      this.subject_data.subject_img = url;
    },
    showgalleryimage() {
      this.showImageModel = true;
    },
  },
};
</script>
